import React, {useState} from 'react';

import {preparedImageUploader} from 'app/utils/fineuploader';
import {gt} from 'app/utils/i18n';

import {FineUploaderArea} from './FineUploaderArea';

import type {NewlyAttachedImageOrVideoType} from 'app/general/types';

type Props = {
  onAddImage: (image: NewlyAttachedImageOrVideoType) => void;
};

export const FineImageUploaderArea = ({onAddImage}: Props) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  return (
    <FineUploaderArea
      uploaderFactory={preparedImageUploader}
      awsUploadProfile="IMAGES"
      onUploadStart={() => setIsProcessing(true)}
      onUploadComplete={(image_ref) => {
        setIsProcessing(false);
        return onAddImage({
          image_ref,
        });
      }}
      uploadListRender={(uploadsFileList) => uploadsFileList}
    >
      {(FileInput, uploader) =>
        isProcessing ? (
          <div className="progress">
            <div className="px-1 progress-bar progress-bar-striped progress-bar-animated w-100">
              {gt('Uploading Image...')}
            </div>
          </div>
        ) : (
          <div className="qq-uploader d-flex flex-column">
            <div className="drop lead">
              <small className="mb-1">
                <i className="fa fa-check-circle mr-1" />
                {gt('Drop here')}
              </small>
            </div>
            <FileInput multiple={false} accept="image/*" uploader={uploader}>
              <div className="qq-upload-button">
                <div className="qq-upload-button">
                  <button className="btn btn-outline-light btn-sm">
                    {gt('Or browse your computer')}
                  </button>
                </div>
              </div>
            </FileInput>
          </div>
        )
      }
    </FineUploaderArea>
  );
};
